import { Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';

@Component({
  selector: 'dividend-modify',
  standalone: false,
  templateUrl: './modify.component.html',
  styleUrl: './modify.component.scss'
})
export class DividendModifyComponent implements OnInit, OnDestroy {

  @ViewChild('modifyForm', { static: true }) modifyForm: NgForm | undefined
  errorMessage!: string

  public dividend: any

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DividendModifyComponent>,
    private currencyPipe: CurrencyPipe
  ) {
    console.error('DividendModifyComponent -> constructor', data)
    this.dividend = data
  }

  ngOnInit(): void {
    console.error('DividendModifyComponent -> ngOnInit')

    //Update total
    this.modifyForm?.valueChanges?.subscribe(async (input:any) => {
      // console.error('DividendCreateComponent -> modifyForm.valueChanges >>>> ', input, this.modifyForm?.controls['dividend.value']?.value)
      
      if(input['dividend.amount'] != undefined && input['dividend.value'] != undefined) {
        this.dividend.total = (parseInt(input['dividend.amount']) * parseFloat(this.currencyPipe.transform(input['dividend.value'], false))).toFixed(2)
        console.error('DividendCreateComponent -> modifyForm.valueChanges', input['dividend.amount'], this.currencyPipe.transform(input['dividend.value'], false), this.dividend.total)
      }
    })
  }

  ngOnDestroy(): void {
    console.warn('DividendModifyComponent -> ngOnDestroy')
  }

  onSubmit(): void {
    console.error('DividendModifyComponent -> onSubmit', this.modifyForm?.value)

    if (this.modifyForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Dividend modified!',
          values: { 
            ...this.dividend, 
            amount: this.modifyForm.value['dividend.amount'].toString(), 
            value: parseFloat(this.currencyPipe.transform(this.modifyForm.value['dividend.value'], false)),
            total: parseFloat(this.currencyPipe.transform(this.modifyForm.value['dividend.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
